import type { ReactNode } from "react";
import { HatTextModal } from "@/components/modal";
import type { DatasetDetailController } from "./useDatasetDetailController";

// 데이터셋 상세에 속한 서브모달 묶음(restore). 라우트 페이지와 전체화면 모달이 같은 controller 로
// 똑같이 표시한다. 본문 바깥의 형제로 렌더해 셸/레이아웃과 분리한다.
//
// Embodiment 상세 모달은 없다. 데이터셋 리뷰 탭이 선택한 embodiment 의 상세를 인라인으로
// 보여준다. 그래서 같은 내용을 모달로 다시 표시하지 않는다. embodiment 정의 자체는
// Embodiment 페이지가 소유하고, 그 페이지의 모달은 그대로 있다.
export function DatasetDetailModals({
  controller,
}: {
  controller: DatasetDetailController;
}): ReactNode {
  return (
    <>
      {/* archived 복구(Activate). 리뷰는 노출·사용을 막지 않는다. 그래서 복구에 게이트가 없다.
          라벨 없는 단순 확인만 표시한다. */}
      {controller.restoreConfirmOpen && controller.currentDataset ? (
        <HatTextModal
          open
          eyebrow={controller.currentDataset.display_name}
          label="Dataset을 활성화합니다."
          caption="비활성화된 Dataset을 활성화 상태로 되돌리시겠습니까?"
          okText="활성화"
          busy={controller.restoring}
          onOkPress={controller.confirmRestore}
          onCancelPress={controller.closeRestoreConfirm}
        />
      ) : null}
    </>
  );
}
